/**
 * Projects + Project Detail actions
 */
export const PROJECTS_ACTIONS = {
  VIEW_MODE_CHANGED: 'view_mode_changed',
  FILTERS_CHANGED: 'filters_changed',
  FILTERS_RESET: 'filters_reset',
  SEARCH_PERFORMED: 'search_performed',
  PROJECT_CLICKED: 'project_clicked',
  PROJECT_SAVED: 'project_saved',
  PROJECT_UNSAVED: 'project_unsaved',
  CATEGORY_CHANGED: 'category_changed',
  TAB_CHANGED: 'tab_changed',
  // Submit project actions
  PROJECT_SELECTED_FOR_EDIT: 'project_selected_for_edit',
  PROJECT_UPDATED: 'project_updated',
  PROJECT_CREATED: 'project_created',
  EDIT_CANCELLED: 'edit_cancelled',
  VIEW_CHANGED: 'view_changed',
} as const;

export const PROJECT_DETAIL_ACTIONS = {
  TAB_CHANGED: 'tab_changed',
  DOCUMENT_VIEWED: 'document_viewed',
  DOCUMENT_DOWNLOADED: 'document_downloaded',
  CONTACT_CLICKED: 'contact_clicked',
  SHARE_CLICKED: 'share_clicked',
  SECTION_VIEWED: 'section_viewed',
  SECTION_TIME_SPENT: 'section_time_spent',
} as const;
